/**
 * Every visible string the Messages list adds for search (ISSUE-1357) and
 * the row quick actions (ISSUE-1362), declared once. Plain American
 * English, straight apostrophes, no dashes.
 */

export const CHAT_SEARCH_LABEL = "Search chats";
export const CHAT_SEARCH_PLACEHOLDER = "Search by name";
export const CHAT_SEARCH_NO_MATCHES_BODY =
  "Check the spelling, or try part of the name.";

export function chatSearchNoMatchesHeadline(searchText: string): string {
  return `No chats match "${searchText}"`;
}

export const CHAT_ROW_MARK_READ_LABEL = "Mark as read";
export const CHAT_ROW_MUTE_LABEL = "Mute";
export const CHAT_ROW_UNMUTE_LABEL = "Unmute";
export const CHAT_ROW_OPEN_LABEL = "Open chat";

export function chatRowActionsLabel(title: string): string {
  return `More for ${title}`;
}

// ISSUE-1358. The "New message" dialog.
export const NEW_MESSAGE_ENTRY_LABEL = "New message";
export const NEW_MESSAGE_TITLE = "New message";
export const NEW_MESSAGE_GROUP_LABEL = "New group";
export const NEW_MESSAGE_GROUP_HINT = "Name a chat and invite a few people.";
export const NEW_MESSAGE_SEARCH_LABEL = "Find someone by username";
export const NEW_MESSAGE_SEARCH_PLACEHOLDER = "username";
export const NEW_MESSAGE_SUGGESTED_TITLE = "Suggested";
export const NEW_MESSAGE_SUGGESTED_EMPTY =
  "People from your pools and chats show up here.";
export const NEW_MESSAGE_SUGGESTED_NO_MATCH =
  "Nobody you know matches that. Try their full username.";
export const NEW_MESSAGE_SELF_MESSAGE = "That's your own username.";

export function newMessageToLabel(displayName: string): string {
  return `Message ${displayName}`;
}
